<!--
 * @Author: Latte
 * @Date: 2021-08-20 09:30:02
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-12 16:07:36
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\liveMgt\liveList\index.vue
-->
<template>
	<div class="app-container">

		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" placeholder="直播标题、直播简介" size="small" prefix-icon="el-icon-search"
					class="search-input" @keyup.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
				<div style="padding-top: 20px;">
					<el-select clearable v-model="curLiveOptins" @change="curLiveOptionChange">
						<el-option v-for="item in liveOptions" :key="item.value" :value="item.value"
							:label="item.label">
						</el-option>
					</el-select>
					<el-select v-if="userDataTypeOptions.length > 0" clearable style="padding-left: 20px;" v-model="curUserDataType"
						@change="curUserDataTypeChange">
						<el-option v-for="item in userDataTypeOptions" :key="item.value" :value="item.value"
							:label="item.name">
						</el-option>
					</el-select>
					<el-select clearable style="padding-left: 20px;" v-model="curLiveState"
						@change="curLiveStateChange">
						<el-option v-for="item in liveStateOptions" :key="item" :value="item"
							:label="item | liveStateTransform">
						</el-option>
					</el-select>
					<el-select clearable style="padding-left: 20px;" v-model="curSortOption"
						@change="curSortOptionChange">
						<el-option v-for="item in sortOptions" :key="item.value" :value="item.value"
							:label="item.label">
						</el-option>
					</el-select>
				</div>

			</div>
		</div>

		<el-table ref="tableRef" v-loading="loading" border :data="allLiveList"
			:header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px" :row-key="getRowKey"
			@row-click="rowClick" @expand-change="expandChange" :expand-row-keys="expandedRow" stripe>

			<el-table-column type="expand">
				<template #default="props">
					<el-form>
						<el-row style="display: flex;">
							<el-col>
								<el-form-item label="H5人数:">{{props.row.memberCountH5}}</el-form-item>
								<el-form-item label="显示H5人数:">
									<el-switch v-model="props.row.isMemberCountShowh5"
										@change="toggleH5ShowMemberCount(props.row)"></el-switch>
								</el-form-item>
								<el-form-item label="APP人数:">{{props.row.memberCount}}</el-form-item>
								<el-form-item label="显示APP人数:">
									<el-switch v-model="props.row.isMemberCountShow"
										@change="toggleAppShowMemberCount(props.row)"></el-switch>
								</el-form-item>
							</el-col>
							<el-col>
                <el-form-item label="应用端显示嘉宾名称:">
                  <el-switch v-model="props.row.isGuestNameShow"
                             @change="toggleAppShowGuestName(props.row)"></el-switch>
                </el-form-item>
                <el-form-item label="应用端显示主持人名称:">
                  <el-switch v-model="props.row.isHostNameShow"
                             @change="toggleAppShowHostName(props.row)"></el-switch>
                </el-form-item>
								<el-form-item label="聊天记录:">
									<el-button type="primary" size="small" @click="go2LiveInfo(props.row,'chatRecord')">
										查看
									</el-button>
								</el-form-item>
								<el-form-item label="答疑列表:">
									<el-button type="primary" size="small" @click="go2LiveInfo(props.row,'question')">查看
									</el-button>
								</el-form-item>
							</el-col>
							<el-col>
                <el-form-item label=" 用户信息:">
                  <el-button type="primary" size="small" @click="go2LiveInfo(props.row,'userInfo')">查看
                  </el-button>
                </el-form-item>
                <el-form-item label=" 禁言列表:">
                  <el-button type="primary" size="small" @click="go2LiveInfo(props.row,'forbidden')">
                    查看
                  </el-button>
                </el-form-item>
								<el-form-item label=" 用户分布:">
									<el-button type="primary" size="small" @click="go2LiveUserDistribution(props.row)">查看</el-button>
								</el-form-item>
								<el-form-item label="直播录制:">
									<el-button type="primary" size="small" @click="go2LiveRecorder(props.row)">查看</el-button>
								</el-form-item>
							</el-col>
              <el-col>
                <el-form-item label="通知管理:">
                  <el-button type="primary" size="small"
                             @click="go2NotificationManager(props.row)">查看</el-button>

                </el-form-item>
<!--                <el-form-item label="会议合影:">-->
<!--                  <el-button type="primary" size="small" @click="">查看</el-button>-->
<!--                </el-form-item>-->
                <el-form-item label="学分卡信息:">
                  <el-button type="primary" size="small" @click="go2LiveInfo(props.row,'creditCard')">查看</el-button>
                </el-form-item>
                <el-form-item label="登记信息:">
                  <el-button type="primary" size="small" @click="go2LiveRegistration(props.row)">查看</el-button>
                </el-form-item>
                <el-col>
                  <el-form-item label="签到信息:">
                    <el-button type="primary" size="small" @click="go2SignMsg(props.row)">查看</el-button>
                  </el-form-item>
                </el-col>
              </el-col>
						</el-row>
					</el-form>

				</template>

			</el-table-column>

			<el-table-column label="#" prop="liveID" align="center"></el-table-column>
			<el-table-column label="chatRoomID" prop="chatRoomID" align="center"></el-table-column>
			<el-table-column v-if="userDataTypeOptions.length > 0" label="领域" prop="userDataType" align="center">
				<template #default="scrope">
					{{scrope.row.userDataType | userDataTypeTransform}}
				</template>
			</el-table-column>
			<el-table-column label="状态" prop="liveState" align="center">
				<template #default="scrop">
					{{scrop.row.liveState | liveStateTransform}}
				</template>
			</el-table-column>
			<el-table-column label="标题" prop="liveTitle" align="center" show-overflow-tooltip></el-table-column>
			<el-table-column label="主播信息" prop="userDataType" align="center">
				<template #default="scrop">
					<el-avatar :key="scrop.row.avatar" :src="getImageUrl(scrop.row.avatar)" fit="scale-down">
					</el-avatar>
					<br />
					{{getName(scrop.row)}}
				</template>
			</el-table-column>
			<el-table-column label="开播时间" prop="LiveBeginDatetime" align="center">
				<template #default="scrop">
					{{scrop.row.liveBeginDatetime | formatDateTime}}
				</template>
			</el-table-column>
			<el-table-column label="更新时间" prop="modifyTime" align="center">
				<template #default="scrop">
					{{scrop.row.modifyTime | formatDateTime}}
				</template>
			</el-table-column>
      <el-table-column label="观看人数" prop="totalMemberCount" align="center"></el-table-column>
      <el-table-column v-if="showVirtuallyMember()" label="真实人数" prop="memberCount" align="center">
				<template #default="scope">
					{{ scope.row.memberCount + scope.row.memberCountH5 }}
				</template>
			</el-table-column>
			<el-table-column v-if="showVirtuallyMember()" label="虚拟人数" prop="totalVirtualUsers" align="center">
				<template #default="scrop">
					<el-button size="small" type="text" @click.stop="openVirtualNumDialog(scrop.row)">
						{{scrop.row.virtualCount}} / {{scrop.row.totalVirtualUsers}}
					</el-button>
				</template>
			</el-table-column>
			<el-table-column label="邀请码" prop="invitationCode" align="center">
				<template #default="scrop">
					<el-button @click.stop="copyPushFlowURL2ClipBoard(scrop.row.invitationCodePC)" size="small"
						type="text">
						{{scrop.row.invitationCodePC}}
					</el-button>
				</template>
			</el-table-column>
			<el-table-column label="推流地址" prop="pushFlowURL" align="center">
				<template #default="scrop">
					<el-button type="text" size="small" @click.stop="copyPushFlowURL2ClipBoard(scrop.row.pushFlowURL)">
						复制</el-button>
				</template>
			</el-table-column>


			<el-table-column label="操作" prop="totalVirtualUsers" align="center" width="200">
				<template #default="slotData">
					<el-button type="primary" size="small" @click.stop="openInfoDialog(slotData.row)">修改直播
					</el-button>
					<el-button type="danger" size="small" v-if="slotData.row.isDeleted == false"
						@click.stop="deleteLive(slotData.row)">删除直播</el-button>
					<el-button type="primary" size="small" v-else @click.stop="resumeLive(slotData.row)">恢复直播
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination hide-on-single-page background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
			:current-page="pageOpt.currentPage" @current-change="currentPageChange" />

		<!-- 发送通知对话框 -->
		<el-dialog title="发送通知" :visible.sync="SMS.dialog" width="50%" :close-on-click-modal="false">
			<el-form :model="SMS" status-icon ref="SMSform">
				<el-form-item label="直播主题：" prop="content">
					<el-input type="textarea" v-model="SMS.content" :autosize="{ minRows: 3, maxRows: 3 }"
						maxlength="40" show-word-limit placeholder="请输入直播主题(不超过40字)"></el-input>
				</el-form-item>

				<el-form-item class="phone" v-for="(item, index) in SMS.phoneList" :key="item.id"
					:label="'发送对象' + (index + 1) + '：'" :rules="[
            { required: true, message: '请输入电话号码', trigger: 'blur' },
            {
              pattern: /^1[12345789]\d{9}$/,
              message: '请输入正确的手机号码',
              trigger: 'blur',
            },
          ]" :prop="'phoneList.' + index + '.phoneNumber'">
					<el-input class="phone-input" v-model.number="SMS.phoneList[index].phoneNumber"
						placeholder="请输入电话号码"></el-input>
					<el-button class="deleteButton" type="danger" @click.stop="deleteInput(index)"><i
							class="el-icon-remove-outline">删除</i></el-button>
				</el-form-item>

				<el-form-item class="operation">
					<el-button @click.stop="sendSMS('SMSform')">提交</el-button>
					<el-button @click.stop="addInput">
						<i class="el-icon-circle-plus-outline" @click.stop="addInput()">增加</i>
					</el-button>
					<el-button @click="resetForm('SMSform')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 编辑直播间信息 -->
		<el-dialog title="编辑直播间信息" width="50%" :visible.sync="infoDialog">
			<el-form :model="info" ref="infoForm">
				<el-form-item label="直播间ID">
					<el-input v-model="info.liveID" disabled></el-input>
				</el-form-item>

				<el-form-item label="状态">
					<el-select v-model="info.liveState">
						<el-option v-for="item in liveStateOptions" :key="item" :value="item"
							:label="item | liveStateTransform">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="直播间标题">
					<el-input v-model="info.liveTitle" type="text" maxlength="80"></el-input>
				</el-form-item>

				<el-form-item label="直播间简介">
					<el-input v-model="info.liveDescription" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
						maxlength="400"></el-input>
				</el-form-item>

				<el-form-item label="开播时间">
					<div class="block" style="margin-top: 40px">
						<el-date-picker v-model="info.liveBeginDatetime" type="datetime" value-format="yyyy-MM-dd HH:mm"
							placeholder="选择日期"></el-date-picker>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click.stop="editLiveInfo">提交</el-button>
					<el-button @click="infoDialog = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 编辑虚拟人数 -->
		<el-dialog title="编辑虚拟人数" :visible.sync="virtualNumDialog" width="50%" :close-on-click-modal="false">
			<el-form :model="virtualForm" ref="virtualForm" :rules="virtualRules">
				<el-form-item label="直播间ID">
					<el-input v-model="virtualForm.liveID" disabled></el-input>
				</el-form-item>

				<el-form-item label="当前虚拟人数" prop="virtualCount">
					<el-input v-model="virtualForm.virtualCount" type="number"></el-input>
				</el-form-item>

				<el-form-item label="虚拟总人数" prop="totalVirtualUsers">
					<el-input v-model="virtualForm.totalVirtualUsers" type="number"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click.stop="setVirtualNum('virtualForm')">提交</el-button>
					<el-button @click.stop="virtualNumDialog = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import Vue from "vue";
	import myTable from "@/components/MyTable/index";
	import {
		getLiveList,
		sendNotification,
		update,
    updateLiveConfig,
		deleteLive,
		resumeLive,
		getProvinceData,
		getAllAudienceList,
		getH5AudienceList,
		getReserveUserList,
		getChatRecords,
		setVirtualAudienceNum,
	} from "@/api/mai/liveManagement/liveManagement";
	import {
		liveMgtConf
	} from "@/config/tableConfig/mai/liveMgt";
	import {
		handleRes
	} from "@/utils/handleRes";
  import {
    getDisplayName, getUserType
  } from "@/utils/userutil"
	import {
		getCloudUrl,
	} from "@/utils/urlutil"
	import {
		isVaild
	} from "@/utils/validate"
	import {
		copy2Clipboard
	} from "@/utils/clipboard"
  import {deepClone} from "@/utils";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
	export default {
		components: {
			myTable,
		},
		data() {
			let validateCur = (rule, value, callback) => {
				let cur = Number(value);
				let total = Number(this.virtualForm.totalVirtualUsers);
				console.log(cur, total, value);
				if (value === "") {
					callback(new Error("请输入虚拟人数"));
				} else if (cur > total) {
					callback(new Error("当前虚拟人数不得大于虚拟总人数"));
				} else {
					callback();
				}
			};

			let validateTotal = (rule, value, callback) => {
				let cur = Number(this.virtualForm.virtualCount);
				let total = Number(value);
				console.log(cur, total);
				if (value === "") {
					callback(new Error("请输入虚拟人数"));
				} else if (cur > total) {
					callback(new Error("当前虚拟人数不得大于虚拟总人数"));
				} else {
					callback();
				}
			};

			return {
        navigationKey:"liveList",

				expandedRow: [],
				loading: false, // 加载开关
				allLiveList: [], // 所有直播列表
				searchValue: "",
				liveOptions: [{
					label: "所有直播",
					value: 0
				}, {
					label: "正在直播",
					value: 1
				}, {
					label: "直播预告",
					value: 2
				}],
				curLiveOptins: "",
				liveStateOptions: [0, 1, 2, 3, 4],
				curLiveState: "",
				curUserDataType: "",
				userDataTypeOptions: [],
				curSortOption: "",
				sortOptions: [{
					label: "按开播时间排序",
					value: "liveBeginDatetime"
				}, {
					label: "按总人数排序",
					value: "totalMemberCount"
				}],

				// 分页配置
				pageOpt: {
					currentPage: 1,
					pageSize: 10,
					totalCount: 0,
				},
				phoneID: 1,
				SMS: {
					content: "", // 短信通知内容
					liveID: 0, // 直播ID
					dialog: false, // 是否显示短信通知对话框
					phoneList: [
						// 发送对象手机号集合
						{
							id: 0,
							phoneNumber: "", // 发送对象手机号码
						},
					],
				},
				infoDialog: false, // 是否显示编辑直播间对话框
				info: {
					liveID: Number,
					liveState: Number,
					liveTitle: "",
					liveDescription: "",
					liveBeginDateTime: "",
					watchCount: Number,
				},
				liveState: "", // 当前直播状态
				virtualNumDialog: false, // 是否显示虚拟人数编辑对话框
				virtualForm: {
					liveID: 0,
					totalVirtualUsers: "", // 虚拟用户总人数
					virtualCount: "", // 当前虚拟用户
				},
				virtualRules: {
					virtualCount: [{
						validator: validateCur,
						trigger: "blur"
					}],
					totalVirtualUsers: [{
						validator: validateTotal,
						trigger: "blur"
					}],
				},
			};
		},

		provide() {
			this.pageOpt = Vue.observable(this.pageOpt);

			return {
				pageOpt: this.pageOpt,
			};
		},

		methods: {

      showVirtuallyMember(){
        return this.config.SHOW_VIRTUALLY_MEMBER === 'true'
      },
			getName(user) {
				return getDisplayName(user)
			},
			getImageUrl(path) {
				return getCloudUrl(path)
			},
			currentPageChange(curPage) {
				this.pageOpt.currentPage = curPage
				this.refreshCurrentList()
			},
			curUserDataTypeChange() {
				this.pageOpt.currentPage = 1
				this.refreshCurrentList()
			},
			curLiveStateChange() {
				this.pageOpt.currentPage = 1
				this.refreshCurrentList()
			},
			curSortOptionChange() {
				this.pageOpt.currentPage = 1
				this.refreshCurrentList()
			},
			search() {
				this.pageOpt.currentPage = 1
				this.refreshCurrentList()
			},
			curLiveOptionChange() {
				this.pageOpt.currentPage = 1
				this.refreshCurrentList()
			},
			/**
			 * 返回table的row key
			 * @param {Object} row
			 */
			getRowKey(row) {
				return row.liveID
			},
			rowClick(row) {
				this.$refs.tableRef.toggleRowExpansion(row)
			},
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {
				this.getAllLiveList();
			},
			/**
			 * table的展开改变回调
			 * @param {Object} row
			 * @param {Object} expandedRows
			 */
			expandChange(row, expandedRows) {
				if (this.expandedRow.indexOf(row.liveID) >= 0) {
					this.expandedRow = []
				} else {
					this.expandedRow = [row.liveID]
				}

			},
			getAllLiveList() {
				this.loading = true;
				const params = {
					keyWord: this.searchValue,
					liveID: "",
					liveType: this.curLiveOptins | 0,
					pageIndex: this.pageOpt.currentPage,
					pageSize: this.pageOpt.pageSize,
					sortName: this.curSortOption,
					sortOrder: "",
				};
				let where = []
				if (isVaild(this.curUserDataType)) {
					where.push({
						"field": "userDataType",
						"value": this.curUserDataType,
						"op": "equal"
					})
				}
				if (isVaild(this.curLiveState)) {
					where.push({
						"field": "liveState",
						"value": this.curLiveState,
						"op": "equal"
					})
				}
				if (where.length > 0) {
					params.where = where
				}

        setNavigationItemWithObj(this.navigationKey,{
          searchValue:this.searchValue,
          curLiveOptins:this.curLiveOptins,
          currentPage: this.pageOpt.currentPage,
          curSortOption:this.curSortOption,
          curUserDataType:this.curUserDataType,
          curLiveState:this.curLiveState
        })

				getLiveList(params).then((res) => {
          handleRes(res,()=>{
            this.allLiveList = res.data.list;
            this.pageOpt.totalCount = res.data.total;
          })

					this.utils.stopLoading(this);
				});
			},

			/**
			 * H5是否显示人数切换
			 */
			toggleH5ShowMemberCount(live) {
				updateLiveConfig({liveID:live.liveID,isMemberCountShowh5:live.isMemberCountShowh5})
			},
			/**
			 * APP是否显示人数切换
			 * @param {Object} live
			 */
			toggleAppShowMemberCount(live) {
        updateLiveConfig({liveID:live.liveID,isMemberCountShow:live.isMemberCountShow})
			},
      /**
       * APP是否显示嘉宾名称
       * @param {Object} live
       */
      toggleAppShowGuestName(live) {
        updateLiveConfig({liveID:live.liveID,isGuestNameShow:live.isGuestNameShow})
      },
      /**
       * APP是否显示主持人名称
       * @param {Object} live
       */
      toggleAppShowHostName(live) {
        updateLiveConfig({liveID:live.liveID,isHostNameShow:live.isHostNameShow})
      },
			/**
			 * 复制推流地址到剪切板
			 * @param {Object} text
			 */
			copyPushFlowURL2ClipBoard(text) {
				if (copy2Clipboard(text)) {
					this.$message.success("复制成功")
				}
			},
			/**
			 * 复制邀请码到剪切板
			 * @param {Object} text
			 */
			copyInvidedCode2ClipBoard(text) {
				if (copy2Clipboard(text)) {
					this.$message.success("复制成功")
				}
			},
			/**
			 * @description: 打开发送短信对话框
			 * @param {*} scope
			 * @return {*}
			 */
			openSMSDialog(scope) {
				this.SMS.liveID = scope.liveID;
				this.SMS.dialog = true;
				// this.sendSMS(scope)
			},

			/**
			 * @description: 删除对应号码输入框
			 * @param {*} index
			 * @return {*}
			 */
			deleteInput(index) {
				if (this.SMS.phoneList.length <= 1) {
					return false;
				}
				this.SMS.phoneList.splice(index, 1);
			},

			/**
			 * @description: 增加号码输入框
			 * @param {*}
			 * @return {*}
			 */
			addInput() {
				this.SMS.phoneList.push({
					id: this.phoneID++,
					phoneNumber: "",
				});
			},

			/**
			 * @description: 发送短信
			 * @param {*} formName
			 * @return {*}
			 */
			sendSMS(formName) {
				this.$refs[formName].validate((valid) => {
					if (!valid) {
						return false;
					} else {
						this.loading = true;
						console.log(this.SMS);
						let phoneNumberList = [];
						this.SMS.phoneList.forEach((element, index) => {
							phoneNumberList[index] = element.phoneNumber;
						});
						console.log(phoneNumberList);
						const data = {
							content: this.SMS.content,
							liveID: this.SMS.liveID,
							phoneList: phoneNumberList,
						};

						console.log(data);
						sendNotification(data).then((res) => {
							handleRes(res);
							this.SMS.dialog = false;
							this.utils.stopLoading(this);
						});
					}
				});
			},

			/**
			 * @description: 重置发送短信对话框
			 * @param {*} formName
			 * @return {*}
			 */
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},

			/**
			 * @description: 打开修改直播间对话框
			 * @param {*} scope
			 * @return {*}
			 */
			openInfoDialog(scope) {
				this.infoDialog = true;
				// console.log(scope);
				this.info = deepClone(scope);
        this.info.liveBeginDatetime = this.$options.filters["formatDateTime"](this.info.liveBeginDatetime)
				this.liveState = scope.liveState
        // console.log(JSON.stringify(this.info))
			},

			/**
			 * @description: 提交直播间修改信息
			 * @param {*}
			 * @return {*}
			 */
			editLiveInfo() {
				const data = {
					liveID: this.info.liveID,
          liveRoomID:this.info.liveRoomID,
					liveState: this.info.liveState,
					liveTitle: this.info.liveTitle,
					liveDescription: this.info.liveDescription,
					liveBeginDatetime: this.info.liveBeginDatetime.replace(" ","T"),
					watchCount: this.info.watchCount,
				};
        // console.log(JSON.stringify(data))
				update(data).then((res) => {
					console.log(res);
					handleRes(res,()=>{
            this.getAllLiveList()
          });
				});
				this.infoDialog = false;
			},

			/**
			 * @description: 查看观众
			 * @param {*} scope
			 * @return {*}
			 */
			go2LiveInfo(scope, tabName) {
				this.$router.push({
					name: "liveInfo",
					query: {
						liveID: scope.liveID,
						tabName: tabName
					},
				});
			},

			/**
			 * @description: 打开设置虚拟人数对话框
			 * @param {*} scope
			 * @return {*}
			 */
			openVirtualNumDialog(scope) {
				this.virtualForm = deepClone(scope);
				this.virtualNumDialog = true;
			},

			/**
			 * @description: 设置虚拟人数
			 * @param {*} formName
			 * @return {*}
			 */
			setVirtualNum(formName) {
				this.$refs[formName].validate((valid) => {
					if (!valid) {
						return false;
					} else {
						const data = {
							liveID: this.virtualForm.liveID,
							totalVirtualUsers: Number(this.virtualForm.totalVirtualUsers),
							virtualCount: Number(this.virtualForm.virtualCount),
						};

						setVirtualAudienceNum(data).then((res) => {
							handleRes(res,()=>{
                this.getAllLiveList()
              });
						});
						this.virtualNumDialog = false;
					}
				});
			},

			/**
			 * @description: 删除直播
			 * @param {*} scope
			 * @return {*}
			 */
			deleteLive(scope) {
				this.$confirm("是否删除该直播?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then((res) => {
						this.loading = true;
						console.log(res);

						const params = {
							liveID: scope.liveID,
						};

						deleteLive(params).then((rs) => {
							handleRes(rs);
							this.refreshCurrentList();
							this.utils.stopLoading(this);
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},

			/**
			 * @description: 恢复直播
			 * @param {*} scope
			 * @return {*}
			 */
			resumeLive(scope) {
				this.$confirm("是否恢复该直播?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "success",
					})
					.then((res) => {
						this.loading = true;
						console.log(res);

						const params = {
							liveID: scope.liveID,
						};

						resumeLive(params).then((rs) => {
							handleRes(rs);
							this.refreshCurrentList();
							this.utils.stopLoading(this);
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},
			/**
			 * 跳转到通知管理页面
			 */
			go2NotificationManager(row) {
				this.$router.push({
					name: "notificationManagement",
					query: {
						liveID: row.liveID,
						userID: row.hostUserID
					},
				});
			},
			/**
			 * 跳转到用户分布界面
			 * @param {Object} row
			 */
			go2LiveUserDistribution(row){
				this.$router.push({
					name: "liveUserDistribution",
					query: {
						liveID: row.liveID
					},
				});
			},
      /**
       * 跳转到直播录制
       * @param entity
       */
      go2LiveRecorder(entity){
        this.$router.push({
          name: "liveRecorder",
          query: {
            liveID: entity.liveID
          },
        });
      },
      /**
       * 跳转到直播签到信息
       * @param entity
       */
      go2SignMsg(entity){
        this.$router.push({
          name: "liveSignMsg",
          query: {
            liveID: entity.liveID
          },
        });
      },
      /**
       * 跳转到直播登记信息
       * @param entity
       */
      go2LiveRegistration(entity){
        this.$router.push({
          name: "liveRegistration",
          query: {
            liveID: entity.liveID
          },
        })
      }
		},

		created() {
      let navigationKey = getNavigationItemObj(this.navigationKey)
      this.searchValue = navigationKey.searchValue
      this.curLiveOptins = navigationKey.curLiveOptins
      this.pageOpt.currentPage = navigationKey.currentPage
      this.curSortOption = navigationKey.curSortOption
      this.curUserDataType = navigationKey.curUserDataType
      this.curLiveState = navigationKey.curUserDataType

      this.searchValue = this.$route.query.searchValue || ""
      this.userDataTypeOptions = getUserType()
			this.refreshCurrentList();
		},

		watch: {
			"pageOpt.currentPage": {
				deep: true,
				handler(newData, oldData) {
					console.log(" -----------------------------------");
					console.log("handler , this.pageOpt", this.pageOpt);
					console.log("handler , newData", newData);
					console.log("handler , oldData", oldData);
					console.log(" -----------------------------------");
					this.refreshCurrentList();
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-dialog__body {
		flex-wrap: nowrap;

		.phone {
			margin: 0 0 22px 0px;

			.phone-input {
				display: inline-block;
				width: 50%;
				margin-right: 20px;
			}

			.deleteButton {
				display: inline-block;
			}
		}

		.operation {
			display: flex;

			margin-left: 82px;
		}
	}
</style>
